import Vue from 'vue';
import router from '@/router';
import { $Cookies } from '@/utils';
import store from '@/store';

const vm = Vue.prototype;
// const whiteList = ['SchoolMoudle','ResourceDetailInfo', 'RecommendList'];
router.beforeEach(async (to, from, next) => {
  // const uid = $Cookies.get('uid');
  const authToken = $Cookies.get('authToken');
  if (!authToken) {
    store.dispatch('auth/getToken');
  }
  next();

  // if (whiteList.indexOf(to.name) > -1) {
  //   next();
  // } else {
  //   if (uid) {
  //     next();
  //   } else {
  //     store.dispatch('auth/verifyLogin').then(data => {
  //       if (!data.isLogged) {
  //         vm.$SignIn();
  //       } else {
  //         next();
  //       }
  //     });
  //   }
  // }
});
